import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import BackButton from '../components/BackButton';
import Icon from '../components/Icon';
import './styles/AboutUs.css';

const AboutUs = () => {
  const { t } = useTranslation();

  const instagramMessage = () => {
    window.open('https://www.instagram.com/ykitestapp/', '_blank');
  };

  return (
    <div className="about-us-container">
      <Helmet>
        <title>About YKI Testi - Free Finnish Language Test App | YKI Testi</title>
        <meta name="description" content="YKI Testi is a free app to help you prepare for the Finnish YKI language proficiency test. Learn about our mission and how to get in touch." />
        <link rel="canonical" href="https://ykitesti.fi/aboutus" />
      </Helmet>
      <BackButton to="/" label="Home" />
      <h1 className="header">{t('aboutUs')}</h1>

      <div className="about-section">
        <h3 className="about-section-title"><Icon name="book" size={18} /> What is YKI Testi?</h3>
        <p className="description">
          Welcome to YKI Testi! This app is designed to assist you in preparing for the Finnish language test (YKI test).
        </p>
      </div>

      <div className="about-section">
        <h3 className="about-section-title"><Icon name="check" size={18} /> Features</h3>
        <ul className="bullet-list">
          <li>Learn Finnish through the use of flashcards</li>
          <li>Practice and assess your vocabulary skills at your own pace</li>
          <li>Enhance your writing skills through exercises and feedback</li>
          <li>Listen to the correct pronunciation of Finnish words</li>
          <li>Focus on improving your incorrect responses</li>
        </ul>
      </div>

      <div className="about-section">
        <h3 className="about-section-title"><Icon name="target" size={18} /> Our Goal</h3>
        <p className="description">
          To provide a user-friendly platform that adapts to your learning speed and offers valuable tools to enhance your Finnish language proficiency.
        </p>
        <p className="description">
          We are constantly improving the app to provide the best experience for you. Happy learning!
        </p>
      </div>

      <div className="about-section">
        <h3 className="about-section-title"><Icon name="globe" size={18} /> Follow Us</h3>
        <div className="about-social">
          <img
            src={require('../assets/images/insta-icon.png')}
            alt="Instagram"
            className="insta-image"
            onClick={instagramMessage}
          />
          <span className="about-social-text">@ykitestapp</span>
        </div>
      </div>

      <div className="about-section">
        <h3 className="about-section-title"><Icon name="info" size={18} /> Learn More</h3>
        <div className="about-links">
          <Link to="/yki-guide" className="about-link-item">
            <Icon name="clipboard" size={16} /> YKI Test Complete Guide
          </Link>
          <Link to="/study-tips" className="about-link-item">
            <Icon name="bulb" size={16} /> Study Tips &amp; Strategies
          </Link>
          <Link to="/faq" className="about-link-item">
            <Icon name="help" size={16} /> Frequently Asked Questions
          </Link>
        </div>
      </div>

      <Link to="/contact" className="about-contact-link">
        <Icon name="mail" size={16} /> {t('contactUs')}
      </Link>
    </div>
  );
};

export default AboutUs;
